import { CLINICAL_BASE_PATH } from '../constants';

export const IGV_PATH = `${CLINICAL_BASE_PATH}/igv`;

export const SAMPLE_SEQUENCE_RUN_API_URL = '/api/v1/sample_sequence_runs';
export const SAMPLE_SEQUENCE_RUN_IGV_ALIGNMENT_API_URL = (id: string) =>
  `${SAMPLE_SEQUENCE_RUN_API_URL}/${id}/igv_alignment`;
export const SAMPLE_SEQUENCE_RUN_IGV_STATUS_API_URL = (id: string) =>
  `${SAMPLE_SEQUENCE_RUN_API_URL}/${id}/igv_status`;
export const SAMPLE_SEQUENCE_RUN_REQUEST_ALIGNMENT_RESTORE_API_URL = (id: string) =>
  `${SAMPLE_SEQUENCE_RUN_API_URL}/${id}/request_alignment_restore`;
